import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, EstadoFactibilidadCorporativaENUM, sizeTab, useCheckPermissions } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableInspeccionFactibilidadCorporativo from "../shared/TableInspeccionFactibilidadCorporativo";


export default function InspeccionFCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_view_factibilidadcoorporativa);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Inspección Factibilidad Corporativa"}
      visibleReport={true}
    >
      <Box sx={{
        bgcolor: 'background.paper',
        maxWidth: sizeTab,
        paddingBottom: 2
      }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Solicitudes de Inspección'} {...a11yProps(0)} />
          <Tab label={'Finalizadas'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableInspeccionFactibilidadCorporativo
          enableEditing={true} 
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.EN_INSPECCION}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableInspeccionFactibilidadCorporativo
          enableEditing={false} 
          estado_factibilidad={undefined}
          showInspected={true}
        />
      </CustomTabPanel>
      
  

    </SingleTableBoxScene>

  );

}